import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BACKBONE_URL } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private httpClient: HttpClient) { }

  public getSearchResult(searchQuery: string) {
    let address = `${BACKBONE_URL}Search/${searchQuery}`;
    return this.httpClient.get(address);
  }
}
